export const analyticsEvents = {
  selectDistributionToAdd: 'Select Distribution to Add',
  selectNumberOfAccounts: 'Select Number of Accounts on File',
  selectTypesOfAccounts: 'Select Type(s) of Account(s) on File',
  scenarioReset: 'Scenario Reset',
}
